import axios from '../../../../utils/request';

function GET_AROLE(params) {
    return axios.get("/inquiry/AInquiryAutoRuleSetting/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/inquiry/AInquiryAutoRuleSetting/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/inquiry/AInquiryAutoRuleSetting/edit",  {
            ...params
        }  )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/inquiry/AInquiryAutoRuleSetting/editPost",{...params} )
}
function DELE(params) {
    return  axios.get("/inquiry/AInquiryAutoRuleSetting/delete",{
        params: {
            ids:params
        }
    } )
}
function GET_FORM_LIST(params) {
    return  axios.post("/inquiry/AInquiryAutoRuleSetting/add",{...params} )
}

export default {
    GET_AROLE,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE,GET_FORM_LIST
};
